module.exports = __webpack_public_path__ + "static/media/iframe-key-icon.437961f5.svg";